import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "../../lib/auth";

/**
 * Route guard for the Chaplain Portal.
 * - Unauthenticated → redirect to /chaplain-portal/login
 * - Authenticated non-chaplain → redirect to Management Center with a toast
 * - Never renders the chaplain shell before deciding.
 */
export default function ChaplainOnlyRoute({ children }) {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && user && user.role !== "chaplain") {
      toast.message("Management accounts use the CCCHAPS Management Center.");
    }
  }, [loading, user]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/chaplain-portal/login" replace />;
  if (user.role !== "chaplain") {
    return <Navigate to="/care-portal/admin/dashboard" replace />;
  }
  if (user.must_change_password) {
    return <Navigate to="/care-portal/admin/change-password" replace />;
  }
  return children;
}
